import { UploadStrategyBase } from "@utilities/manual-upload-strategies/upload-strategy-base";

export class ManualUploadDialogModel {
    strategy: UploadStrategyBase;
  }
